var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-table-column',{attrs:{"config":_vm.config}},[_vm._l((_vm.config.columns),function(item,index){return (_vm.config.columns)?[(item.type !=='slot')?_c('mu-column-item',{key:index,attrs:{"config":item}}):_vm._t(item.name)]:_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }